var map = {
	"./photo-01-big.jpg": "1RMc",
	"./photo-01.jpg": "nvJ5",
	"./photo-02-big.jpg": "i6Dw",
	"./photo-02.jpg": "ZEb1",
	"./photo-03-big.jpg": "toIw",
	"./photo-03.jpg": "IHsF",
	"./photo-forest-01.jpg": "FnMM",
	"./photo-forest-02.jpg": "sqnm",
	"./photo-forest-03.jpg": "MJeD",
	"./photo-ocean-01.jpg": "VbQd",
	"./photo-ocean-02.jpg": "99YL",
	"./photo-ocean-03.jpg": "Xcwl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "YFoF";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/photo\-.*\.jpg$
// module id = YFoF
// module chunks = 1